<template>
  <ClientOnly>
    <StagingBanner v-if="isNonProd" />
    <div class="grid grid-cols-1 lg:grid-cols-2">
      <div
        class="p-4 md:p-12 flex flex-col gap-12 lg:gap-0 bg-gray-100 min-h-screen"
      >
        <a href="https://www.founderspledge.com" class="w-fit">
          <FoundersPledgeLogo class="w-40 h-auto text-fp-green-5" />
        </a>

        <div
          class="self-center flex-grow flex flex-col h-full md:justify-center w-full max-w-sm"
        >
          <slot />
        </div>
      </div>

      <div class="bg-fp-green-0 hidden lg:flex justify-center h-full">
        <div
          class="max-w-7/10 pb-8 pt-12 flex flex-col gap-4 max-h-screen justify-center items-start"
        >
          <h2 class="text-fp-green-8 font-tiempos leading-none text-5xl">
            <template v-if="source === 'admin'">
              Welcome to the <br />FP Navigator
            </template>
            <template v-else-if="source === 'grantee'">
              Welcome to the <br />Founders Pledge Grantee Portal
            </template>
            <template v-else> Maximize <br />your impact </template>
          </h2>
          <img
            v-if="source === 'admin'"
            class="min-h-0 w-auto object-contain"
            src="@/assets/images/chaos-dog.png"
          />
          <img
            v-else-if="source === 'grantee'"
            class="min-h-0 w-auto object-contain"
            src="@/assets/images/pledge-earth.png"
          />
          <img
            v-else
            class="min-h-0 w-auto object-contain"
            src="@/assets/images/login-illustration.png"
          />
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
import StagingBanner from '~/components/common/StagingBanner.vue'
import FoundersPledgeLogo from '~/../member-webapp-shared/components/fp-logos/FoundersPledgeLogo.vue'

const isNonProd = useRuntimeConfig().public.environment !== 'prod'

defineProps<{
  source: 'admin' | 'member' | 'grantee'
}>()
</script>
